import type { AccountSaveState } from "@softmax/product-ux/account";
import { isUncertainWrite } from "../write-failure";

export function profileSaveState(save: {
  isPending: boolean;
  isSuccess: boolean;
  error: Error | null;
}): AccountSaveState {
  let state: AccountSaveState = { status: "idle" };

  if (save.isPending) state = { status: "saving" };
  else if (save.error) {
    const uncertain = isUncertainWrite(save.error);
    state = {
      status: uncertain ? "uncertain" : "error",
      message: uncertain
        ? "Could not confirm the save. Refresh account before trying again. Your draft is retained."
        : save.error.message,
    };
  } else if (save.isSuccess) state = { status: "saved" };

  return state;
}
